import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  enterpriseTagsKey,
  deleteEnterpriseTagsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { tagsListKey } from '@features/enterprise/constants';

type useDeletetagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeletetags = ({
  setErrorText = () => { },
}: useDeletetagsProps) => {
  const client = useQueryClient();

  const { mutate: deleteTags, isLoading: isDeleteTagsLoading } =
    useMutation({
      mutationFn: (variables: {
        tag_id: number;
        company_id?: number | string;
      }) =>
        axiosInstance
          .post(deleteEnterpriseTagsRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([enterpriseTagsKey]);
          client.invalidateQueries([tagsListKey]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteTags,
    isDeleteTagsLoading,
  };
};
